/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateCreateResponse {
    getFixupPrototypeFunction() { return TemplateCreateResponse.fixupPrototype; }

    static newInstance(model: Partial<TemplateCreateResponse>): TemplateCreateResponse {
        let obj = Object.assign(new TemplateCreateResponse(), model);
        TemplateCreateResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateCreateResponse>): TemplateCreateResponse {
        if (!model) return null;
        return TemplateCreateResponse.newInstance(<TemplateCreateResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateCreateResponse) {
        if (!obj) return;

        models.TemplateCreateResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateCreateResponse): boolean {
        Object.setPrototypeOf(obj, TemplateCreateResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Unique Id of the template
     */
    template_id: string;

}
